import { Injectable } from '@angular/core';
import { apiEndpoints } from '../../constants/api-endpoints';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { HttpUtilityService } from '../http.utility.service';

@Injectable({
  providedIn: 'root',
})
export class BuyerServiceService {
  constructor(private readonly httpUtilityService: HttpUtilityService) {}

  userEmail = sessionStorage.getItem('UserEmail') || '';

  otherBuyerPnaSearch(filter: any, pageNumber: number, pageSize: number) {
    const url = `${apiEndpoints.OtherBuyerPnaSearch}?req_userEmail=${this.userEmail}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return this.httpUtilityService.post<any[]>(url, filter);
  }

  getAssignedPNARequests(params: any): Observable<HttpResponse<any>> {
    const url = `${apiEndpoints.getAssignedPNARequests}`;
    return this.httpUtilityService.getByParam(url, params);
  }

  pnaRequestBuyerAction(
    formDate: any,
    action: string
  ): Observable<HttpResponse<any>> {
    const url = `${apiEndpoints.pnaRequestBuyerAction}/${action}`;
    return this.httpUtilityService.post(url, formDate);
  }
}
